<template>
<div class="wrapper">
<div class="container-fluid bg-green pt-3 position-relative">
  <div class="paint-left pe-none"><img src="https://wanada.org.au/wp-content/themes/wanada-child/img/paint-left.png"/></div>
  <div class="paint-right pe-none"><img src="https://wanada.org.au/wp-content/themes/wanada-child/img/paint-right.png"/></div>
  <div class="row">
    <div class="col-48 ">
      <div class="container">
        <div class="row w-100 mb-7">
          <div class="col-lg-30 col-49 mx-auto text-center text-white position-relative">
            <h1 class="fw-bolder">Search for</h1>
            <div class="fs-1  mb-5">Alcohol & Other Drugs<br>Service Providers</div>
            <div class="col-42 mx-auto greenbook-search__phrase mb-6">
            <div class="input-group  position-relative">
             <div class="input-group-prepend d-md-block d-none">
    <span class="input-group-text" id="basic-addon1"><svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
              <path
                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
            </svg></span>
  </div>
  <input type="search" v-model="searchValue" class="form-control search border-0" name="keyword" id="keyword" minlength="3" role="presentation" autocomplete="off" placeholder="What are you looking for?" aria-label="Username" aria-describedby="basic-addon2">
  <div @click="clickMe" class="input-group-append greenbook-search_click">
  <div class="search-btn" >Search</div>
  </div>


 <div id="datafetch" :class="showResults ? 'hide' : 'show'" class="results col-33 mx-auto" v-if="validName && filterByTerm.length > 0 ">
          <div class="row text-start">
            <div class="search-item-info d-inline-flex align-items-center justify-content-between"><span class="fw-bold">Did you mean?</span></div>
            
            <div  class="col-48" v-for="title in filterByTerm" :key="title.id">
              <span class="" >
                
  <router-link v-if="title.type === 'Service Name'"  class="text-decoration-none  " :to="{name: 'SingleService', params: { title: title.slug } }">
           <span class="search-item"><img class="title-img" alt="Single Service Icon" src="@/assets/service-up-new.png"/>   {{ title.name }} <span v-if="title.subname" class="ms-1"> - {{ title.subname }}</span> <span v-if="title.suburb" class="suburb-pill px-2 ms-2">{{ title.suburb }}</span></span>
          </router-link>

          <router-link v-else  class="text-decoration-none  " :to="{name: 'SingleService', params: { title: title.slug } }">
           <span class="search-item"><img class="title-img" alt="Single Category Icon" src="@/assets/icons/service-up.png"/>   {{ title.name }} <span v-if="title.subname" class="ms-1"> - {{ title.subname }}</span> <span v-if="title.suburb" class="suburb-pill px-2 ms-2">{{ title.suburb }}</span></span>
          </router-link>

                </span>
     
            </div>
            <div class="search-item-info d-inline-flex align-items-center justify-content-between" @click="toggle()"> <span class=" ms-auto">Dismiss Suggestions x </span></div>
          </div>
        </div>
 
</div>

            
       
        <div @click="active = !active" :aria-pressed="active ? 'true' : 'false'" class="row bg-white w-100 p-3 advanced-dd">

          <div class="d-inline-flex align-items-center justify-content-center"> <img class="svg-icons" alt="advanced-filtering" src="@/assets/filtering.png"/> <span class="
          ms-2 text-black">Advanced filtering</span></div>
</div>
 
  <div class="row advanced-filter-row filter-col " :class="{ big: active }">

    <div class="form-group col-md-12 p-3">
    <div class="d-flex flex-column ">
        <label for="name" class="control-label mb-2">Organisation Category</label>
          <select v-model="paramCat">
    
     <option v-for="(category, i) in armixed" :key="i"  :value="category.slug">{{category.name}}</option>
  </select>
    </div>
</div>

   <div class="form-group col-md-12 p-3 text-left">
    <div class="d-flex flex-column align-items-start">
        <label for="name" class="control-label mb-2">Region</label>
          <select v-model="paramReg">
    
   <option v-for="(region, i) in filteredRegion" :key="i"  :value="region">{{region}}</option>
   
  </select>
    </div>
</div>

   <div class="form-group col-md-12 p-3">
    <div class="d-flex flex-column align-items-start">
        <label for="name" class="control-label mb-2">Accreditation</label>
          <select v-model="paramAcc">
    
    <option value="yes">Yes</option>
    <option value="no">No</option>
  </select>
    </div>
</div>

   <div class="form-group col-md-12 p-3">
    <div class="d-flex flex-column align-items-start">
        <label for="name" class="control-label mb-2">Outreach Available</label>
          <select v-model="paramOut">
   
    <option value="yes">Yes</option>
    <option value="no">No</option>
  </select>
    </div>
</div>
    

  </div>

  
</div>

<div class="row w-100">
  <div class="col-42 mx-auto text-center text-white"> Common Searches include:
     <router-link  class="text-decoration-underline" :to="{name: 'SingleService', params: { title: 'community-counselling' }  }">Treatment and support,
            </router-link> 
             <router-link  class="text-decoration-underline" :to="{name: 'SingleService', params: { title: 'withdrawal-detox' }  }">Withdrawal/detox,
            </router-link> 
             <router-link  class="text-decoration-underline" :to="{name: 'SingleService', params: { title: 'outreach' }  }">Outreach
            </router-link> 
</div>
   
  </div>
         </div>
        </div>
        <div class="row position-relative">
          <div class="col-lg-40 col-46 mx-auto">
           <ul class="nav nav-tabs nav-justified fw-bold d-md-flex d-block">
      <li class="nav-item mx-lg-2 mx-1">
        <a class="nav-link d-flex flex-row align-items-center justify-content-center" @click.prevent="setActive('home')" :class="{ active: isActive('home') }" href="#home">
           <div class="d-inline-flex align-items-center justify-content-center"><img class="svg-icons" alt="explore-by-category" src="@/assets/cat.png"/> <span class="
          ms-2">Explore by Categories</span></div>
</a>
      </li>
      <li class="nav-item mx-lg-2 mx-1">
        <a class="nav-link d-flex flex-row align-items-center justify-content-center  " @click.prevent="setActive('profile')" :class="{ active: isActive('profile') }" href="#profile"> 
          <div class="d-inline-flex align-items-center justify-content-center"><img class="svg-icons" alt="explore-by-map" src="@/assets/region.png"/>
        <span class="ms-2">Explore by Map</span></div>

  </a>
      </li>

          <li class="nav-item mx-lg-2 mx-1">
        <a class="nav-link d-flex flex-row align-items-center justify-content-center  " @click.prevent="setActive('contact')" :class="{ active: isActive('contact') }" href="#contact"> 
           <div class="d-inline-flex align-items-center justify-content-center"><img class="svg-icons" alt="explore-by-region"  src="@/assets/map.png"/> <span class="
          ms-2">Explore by Region</span></div>

  </a>
      </li>
                <li class="nav-item mx-lg-2 mx-1">
        <a class="nav-link d-flex flex-row align-items-center justify-content-center  " @click.prevent="setActive('about')" :class="{ active: isActive('about') }" href="#about"> 
           <div class="d-inline-flex align-items-center justify-content-center"><img class="svg-icons" alt="explore-by-region"  src="@/assets/map.png"/> <span class="
          ms-2">About the Green Book</span></div>

  </a>
      </li>
  
    </ul>
    </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="container-fluid bg-white position-relative">
  <div class="row">
    <div class="col-48">


      <div class="tab-content " id="myTabContent">
        <div class="tab-pane fade show" :class="{ 'active show': isActive('home') }" id="home">
          <div class="container bg-white">
            <div class="row">
              <div class="col-38  mx-auto">
                <div class="row">

                  <div class="col-lg-12 col-md-24 cat-column" v-for="category in armixed" :key="category.slugCat">
                    <router-link class="text-decoration-none text-center d-flex flex-column align-items-center justify-content-start p-5"
                      :to="{name: 'SingleService', params: { title: category.slug }  }"><img class="cat-icons" alt="category-image"
                        :src="baseURL  + category.slug +'.png'"><span class="fw-bold text-black"> {{category.name}}</span>
                    </router-link>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane fade fullMap" :class="{ 'active show': isActive('profile') }" id="profile">
          <GoogleMap :items="services" />
        </div>

        <div class="tab-pane fade" :class="{ 'active show': isActive('contact') }" id="contact">
          <div class="container bg-white">
            <div class="row">
              <div class="col-38  mx-auto">
                <div class="row row-cols-1 row-cols-md-3 g-4">

                  <div class="col" v-for="(region, i) in filteredRegion" :key="i">
                    <div class="card">
                      <div class="card-body">
                        <router-link class="text-decoration-none text-center d-flex flex-column align-items-center justify-content-start p-5"
                          :to="{name: 'SingleService', params: { title: region }  }">
                          <span class="fw-bold text-black">
                            <h5 class="card-title"><img class="cat-icons" alt="category-image"
                                :src="baseURL  + region.replace(/\s+/g, '-').toLowerCase() +'.jpg'">{{region}}</h5>
                          </span>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

                <div class="tab-pane fade" :class="{ 'active show': isActive('about') }" id="about">
          <div class="container bg-white">
            <div class="row">
              <div class="col-38  mx-auto">
                <div class="row mt-0 py-5">

<div class="col-48 text-start px-xl-0 px-3">
  
    <h2>About the Green Book</h2>
<p>The Green Book is a directory of alcohol and other drug (AOD) services in Western Australia.</p>
<p>The aims of the Green Book are to:</p>
<ul>
<li>Provide a concise directory of the alcohol and other drug services available in Western Australia;</li>
<li>Raise awareness of the diverse range of services available to the community, and;</li>
<li>Facilitate referrals, including self-referrals, to quality alcohol and other drug services.</li>
</ul>
<p>The GreenBook is a project of the Western Australian Network of Alcohol and other Drug Agencies (WANADA).</p>
<p>Feedback and updates are welcome. Please contact WANADA on (08) 6557 9400 or email <a href="mailto:info@greenbook.org.au">info@greenbook.org.au</a>.</p>

</div> 
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>


    </div>
  </div>
</div>



</div>
</template>

<script>
import slugify from 'slugify'
import { dataPromise } from '@/stores/store.js';
import GoogleMap from '@/components/GoogleMap';

export default {
name:'Home',
  components: {
   GoogleMap,
  
  },
  data(){
    return {
      showResults: false,
      baseURL:'https://wanada.org.au/wp-content/themes/wanada-child/img/',
      filteredCategories:[],
      filteredRegion:[],
      filteredTags:[],
      paramCat: '',
      paramOut: '',
      paramReg: '',
      paramAcc: '',
      active: false,
      activeItem: 'home',
      servicesJson: '',
      search:'',
      services:[],
      titles:[],
      searchValue:'',
      categories:[],
      tags:[],
      categoriesValue:[],
      orgs:[],
      join: [],
      armixed: [],
      arrFiltered:[],
      slug: '',
      catUniq:[],
      bigArray: [],
      simpleArr: [],
      singleCat: [],
      validName: false,
      componentLoaded: false,
      center: {lat: 51.093048, lng: 6.842120},
      mapStyle: {
         draggable:true,
           zoomControl: false,
           mapTypeControl: false,
           scaleControl: false,
           streetViewControl: false,
           rotateControl: false,
           fullscreenControl: false,
           animation: 2,
           disableDefaultUI: true,
           styles: [{featureType: "water",elementType: "geometry",stylers: [{color: "#e9e9e9"},{lightness: 17 } ] }, { featureType: "landscape", elementType: "geometry", stylers: [ { color: "#f5f5f5" }, { lightness: 20 } ] }, { featureType: "road.highway", elementType: "geometry.fill", stylers: [ { color: "#ffffff" }, { lightness: 17 } ] }, { featureType: "road.highway", elementType: "geometry.stroke", stylers: [ { color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 } ] }, { featureType: "road.arterial", elementType: "geometry", stylers: [ { color: "#ffffff" }, { lightness: 18 } ] }, { featureType: "road.local", elementType: "geometry", stylers: [ { color: "#ffffff" }, { lightness: 16 } ] }, { featureType: "poi", elementType: "geometry", stylers: [ { color: "#f5f5f5" }, { lightness: 21 } ] }, { featureType: "poi.park", elementType: "geometry", stylers: [ { color: "#dedede" }, { lightness: 21 } ] }, { elementType: "labels.text.stroke", stylers: [ { visibility: "on" }, { color: "#ffffff" }, { lightness: 16 } ] }, { elementType: "labels.text.fill", stylers: [ { saturation: 36 }, { color: "#333333" }, { lightness: 40 } ] }, { elementType: "labels.icon", stylers: [ { visibility: "off" } ] }, { featureType: "transit", elementType: "geometry", stylers: [ { color: "#f2f2f2" }, { lightness: 19 } ] }, { featureType: "administrative", elementType: "geometry.fill", stylers: [ { color: "#fefefe" }, { lightness: 20 } ] }, { featureType: "administrative", elementType: "geometry.stroke", stylers: [ { color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 } ] } ]        
      },
    }
    },
    computed: {
    filterByTerm() {
      return this.join.filter(title => {
        return title.name.toLowerCase().match(this.searchValue.toLowerCase());
      });
    }
  },

   methods: {
      toggle() {
      this.showResults = true;
     
    },
     	isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },

    clickMe(){
      //console.log('clickme')

      this.$router.push({path:'/search', query:{
        category: this.paramCat|| undefined,
        region: this.paramReg || undefined,
        outreach: this.paramOut || undefined,
        accreditation: this.paramAcc || undefined,
        name: this.searchValue || undefined}})
    },


    

    searchServices(){
       this.servicesJson.forEach(service => {
       let arrFiltered = []
       let services = []
       let titles= []
       let categories = []
       let categoriesValue = []
       let filteredRegion = []
       let tags = []
      
            this.services.push(service) 
            this.categories.push(service.categoriesLabel)
            // if(service.tag.length > 0) {
            // this.tags.push(service.tag)
            // }
            this.categoriesValue.push(service.categoriesValue)
            this.titles.push({'name':service.name, 'subname':service.subName, 'type': 'Service Name', 'slug':service.slug, 'suburb':service.suburb})
            this.bigArray = this.categories.flat() 
            this.bigArrayTwo = this.categoriesValue.flat()
            this.filteredRegion.push(service.region)
         console.log(service.tag.length) 
     })
    //  console.log(this.filteredRegion)
this.filteredTags = [...new Set( this.tags.flat())];
// console.log(this.filteredTags);
this.filteredCategories = [...new Set( this.categories.flat())];
this.filteredRegion = [...new Set(this.filteredRegion)];

const newRegion = this.filteredRegion;
const regionOrder = ['Statewide', 'East Metro', 'North Metro', 'South Metro', 'South West', 'Great Southern', 'Wheatbelt', 'Gascoyne', 'Midwest', 'Goldfields', 'Kimberley', 'Pilbara'];

const sortedObj = newRegion.sort((a, b) => {
    return (
        regionOrder.indexOf(a) - regionOrder.indexOf(b)
    );
});

//  console.log(this.filteredRegion)
const catUniq = [...new Set(this.bigArray)];
const catSlugUniq = [...new Set(this.bigArrayTwo)];


let armixed = []
        var ar1 = catUniq;
        var ar2 = catSlugUniq;
        this.armixed = ar1.map(function (x, i) { 
                        return {'name':x, 'type': 'Category', 'slug':ar2[i] }
                      });

const tables = this.armixed;
// console.log(tables)
const importOrder = ['Community (non-residential) counselling, support and/or case management', 'Residential Treatment / Therapeutic Community', 'Withdrawal/detox service', 'Harm Reduction service', 'Sobering Up Centre/Patrol/Community Connectors', 'AOD Prevention and/or Community Development', 'Consumer Advocacy', 'Outreach', 'Prison inreach and transition', 'Womens specific services', 'Information, referrals and support', 'Community Alcohol and other Drug Service', 'Mens Specific Service', 'Aboriginal Community Controlled Organisation', 'Youth Specific Services', 'Family Friendly'];
const sortByObject = importOrder
.reduce((obj, item, index) => {
  return {
    ...obj,
    [item]: index,
  };
}, {});

const customSort = tables.sort((a, b) => sortByObject[a.name] - sortByObject[b.name]);
// console.log(customSort)
this.join = this.titles.concat(this.armixed)

    
    }

  },
    watch: {
    searchValue: function(newValue) { 
      if(newValue.length > 3) {
        this.validName = true;
         this.showResults = false;
      } else if (newValue.length < 3) {
        this.validName = false;
      }
    }
  },
  mounted() { 
  // 
//  console.log(this.componentLoaded)
   if (this.componentLoaded ===  false) {
     console.log('mounted');
    
     //console.log(this.serviceJson)
   }
},

          created() {
               dataPromise.then(data => {
  //console.log(data);
  this.servicesJson = data
  this.searchServices();
   console.log('created');
});
         
     
        },
    }
</script>

<style lang="scss">
// @import '@/assets/app.scss';
</style>
